module.exports = __webpack_public_path__ + "img/vcontroller-show-btn3.ea731f76.png";